"use strict";

module.exports = function(){
  return {
    restrict: 'A',
    scope: {
      calculate: "=",
      calculateTrigger: "@"
    },
    require: '^ngModel',
    link: function(scope, elem, attr, ngModel) {
      scope.$watch(function() {
        return scope.$parent.$parent.$parent.$parent.$parent.model;
      }, function() {
        angular.element(document.getElementById(scope.calculateTrigger)).bind('click', function () {
          // ouch
          var result = scope.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$eval(scope.calculate);
          if (isNaN(result)){
            result = scope.$parent.$parent.$parent.$parent.$parent.$parent.$eval(scope.calculate);
          }

          // calculate the factor for the decimal precision
          var factor = 100;
          if (attr['step']){
            factor = 1 / parseFloat(attr['step']);
          }

          result = Math.round(result * factor) / factor;
          elem.val(result);
          ngModel.$setViewValue(result);
        });
      }, true);
    }
  };
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/patients/components/schema-form-calculator/schema-form-calculator.js